module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.slideshow.length) ? _c('amp-carousel', {
    staticClass: "carousel",
    attrs: {
      "width": "600",
      "height": "600",
      "layout": "responsive",
      "type": "slides",
      "loop": "",
      "controls": ""
    }
  }, _vm._l((_vm.slideshow), function(val, key) {
    return _c('amp-img', {
      key: key,
      attrs: {
        "src": val.style_600x600,
        "width": "600",
        "height": "600",
        "layout": "responsive"
      }
    })
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4111042","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/gallery/amp/AmpCarousel.vue
// module id = 1786
// module chunks = 33